import React from 'react';
export function Separator() {
  return <div className="bg-arih-light-bg py-4 w-full" aria-hidden="true" data-id="element-203" />;
}